import type { StyleFunctionProps } from '@chakra-ui/theme-tools';
import { mode, transparentize } from '@chakra-ui/theme-tools';

const baseStyle = {
  px: '.5em',
  py: '.35em',
  fontWeight: 'extrabold',
  lineHeight: '1.25',
  borderRadius: '.4em',
};

const variantSubtle = (props: StyleFunctionProps) => {
  const { colorScheme: c, theme } = props;
  const darkBg = transparentize(`${c}.300`, 0.16)(theme);
  return {
    bg: mode(`${c}.200`, darkBg)(props),
    color: mode(`${c}.800`, `${c}.300`)(props),
  };
};

const variants = {
  subtle: variantSubtle,
};

export default {
  baseStyle,
  variants,
};
